/**
 * Same rule as `shouldShowMinimizedWidget` in `OneChatChatWrapper`: when `true`,
 * `OneChatChatWrapper` renders `<MinimizedChat setRef={setRef} />`; when `false`, only
 * `<OneChat />` when `useResizeWidgetWindow().isOpened` / `selectLayout` is expanded.
 *
 * Classic mobile (`isMobile` + `!isStudioSite()` + `!isStudioEditor` from `useEnvironment`):
 * always `false` — minimized entry is `MobileActionBarButton` + `useMobileActionBarButton`
 * (`host.mobile` / `Wix.Mobile`), not `MinimizedChat`.
 *
 * Studio site mobile or Editor X mobile: `true` whenever collapsed (`isOpened` from
 * `useResizeWidgetWindow` is `false`).
 *
 * After `useForcedExpandInViewer` runs `expandWidget` (`layoutThunks`), `isOpened` stays
 * `true` until `minimizeWidget` or equivalent; then `MinimizedChat` can show again.
 */
export function shouldShowMinimizedOneChatWidget(opts: {
  isMobile: boolean;
  isOpened: boolean;
  isStudioSite: boolean;
  isStudioEditor: boolean;
}): boolean {
  const { isMobile, isOpened, isStudioSite, isStudioEditor } = opts;

  if (isMobile && !isStudioSite && !isStudioEditor) {
    return false;
  }

  return !isOpened;
}
